module.exports = __webpack_public_path__ + "static/media/background_das_image.2c6db2e7.jpg";